<template>
    <!-- 导航 -->
    <NavBar color="#343A41" bgcolor="white">
        <template v-slot:title>
            <span class="nav-title">消息中心</span>
        </template>
    </NavBar>

    <main>
        <!-- <div class="top">
            <div class="box">
                <div class="item active">
                    <img src="@/assets/images/PayMess.png" alt="">
                    <span>支付消息</span>
                </div>
                <div class="item">
                    <img src="@/assets/images/attention.png" alt="">
                    <span>关注提醒</span>
                </div>
                <div class="item" :class="{active: selected == 1}" @click="changeTab(1)">
                    <img src="@/assets/images/doll.png" alt="">
                    <span>个人消息</span>
                </div>
                <div class="item" :class="{active: selected == 2}" @click="changeTab(2)">
                    <img src="@/assets/images/messages.png" alt="">
                    <span>系统消息</span>
                </div>
                <div class="item">
                    <img src="@/assets/images/GiftMess.png" alt="">
                    <span>赠与通知</span>
                </div>
            </div>
        </div> -->
        <van-empty
            :image="require('@/assets/images/kong.png')"
            description="暂无消息"
            v-if="! notices.length"
        />
        <div class="list">
            <div class="list-item" v-for="(notice, index) in notices" :key="index">
                <div class="list-top">
                    <img :src="notice.cover" v-if="notice.cover">
                    <div class="content">{{ notice.title }}</div>
                </div>
                <div class="line"></div>
                <div class="list-btm">
                    <span>{{ notice.time }}</span>
                    <a :href="notice.url" class="right" v-if="notice.url">
                        <span>查看详情</span>
                        <van-icon name="arrow" color="#1F69E7" />
                    </a>
                </div>
            </div>
        </div>
    </main>
</template>

<script src="./Page.js"></script>

<style src="./Page.scss" lang="scss" scoped></style>